import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _sizes;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import MuiIconButton from '@material-ui/core/IconButton';
import classNames from 'classnames';
import { ICON_COMPACT_SIZE, ICON_DEFAULT_SIZE } from '../theme/constants';
var COMPACT_ICON = 'compact';
var DEFAULT_ICON = 'default';
var sizes = (_sizes = {}, _defineProperty(_sizes, COMPACT_ICON, ICON_COMPACT_SIZE), _defineProperty(_sizes, DEFAULT_ICON, ICON_DEFAULT_SIZE), _sizes);

var styles = function styles(_ref) {
  var mixins = _ref.mixins;
  return {
    iconCompact: _objectSpread({}, mixins.size(sizes[COMPACT_ICON])),
    iconDefault: _objectSpread({}, mixins.size(sizes[DEFAULT_ICON])),
    iconWrapper: {
      padding: 9
    }
  };
}; // eslint-disable-next-line prefer-arrow-callback


export var IconButton = React.forwardRef(function IconButton(props, ref) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      variant = props.variant,
      tooltip = props.tooltip,
      TooltipProps = props.TooltipProps,
      rest = _objectWithoutProperties(props, ["children", "classes", "className", "variant", "tooltip", "TooltipProps"]);

  var iconEl = React.Children.only(children);
  var iconClassName = classNames(iconEl.props.className, (_classNames = {}, _defineProperty(_classNames, classes.iconCompact, variant === COMPACT_ICON), _defineProperty(_classNames, classes.iconDefault, variant === DEFAULT_ICON), _classNames));
  var iconButtonClassName = classNames(classes.iconWrapper, className);

  if (!tooltip) {
    return React.createElement(MuiIconButton, _extends({
      className: iconButtonClassName,
      ref: ref
    }, rest), React.cloneElement(iconEl, {
      className: iconClassName
    }));
  }

  return React.createElement(Tooltip, _extends({
    title: tooltip,
    placement: "top"
  }, TooltipProps), React.createElement(MuiIconButton, _extends({
    "aria-label": tooltip,
    className: iconButtonClassName,
    ref: ref
  }, rest), React.cloneElement(iconEl, {
    className: iconClassName
  })));
});
process.env.NODE_ENV !== "production" ? IconButton.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  TooltipProps: PropTypes.object,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  variant: PropTypes.oneOf([COMPACT_ICON, DEFAULT_ICON])
} : void 0;
IconButton.defaultProps = {
  className: '',
  tooltip: null,
  variant: DEFAULT_ICON,
  TooltipProps: null
};
export default withStyles(styles, {
  name: 'IconButton'
})(IconButton);